import React, { FC, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import UploadCsvOrders from './UploadCsvOrders'

const uploadCsvDownloadBtnHoverStyle = `
.upload-csv-download-btn:hover i {
    color: #ffffff !important;
}
`

type Props = {
    show: boolean
    handleClose: () => void
    platformId: string | undefined
}

const UploadCsvOrdersModal: FC<Props> = ({ show, handleClose, platformId }) => {
    const [busy, setBusy] = useState(false)

    return (
        <>
            <style>{uploadCsvDownloadBtnHoverStyle}</style>
            <Modal show={show} onHide={handleClose} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Upload Orders CSV</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <UploadCsvOrders
                        show={show}
                        handleClose={handleClose}
                        platformId={platformId}
                        onBusyChange={setBusy}
                    />
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" disabled={busy} onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UploadCsvOrdersModal
